<template>
    <div>
        <top @mouse-enter="showCategory += 1" :keyword="keyword" @mouse-leave="showCategory -= 1"></top>

        <category :category="[]" :subCategory="{}" :showCategory="showCategory"></category>
        <div class="courseView">
            <div class="page-width">
                <div class="posnav" style="text-align: left;" v-if="categoryId">
                    <a
                        v-if="category"
                        style="cursor: pointer;"
                        @click="subCategoryId = null"
                    >{{ category.name }}</a>
                    <em>&gt;</em>
                    <a>{{ subCategoryName }}</a>
                </div>

                <section class="filterbox" v-if="categoryId">
                    <ul>
                        <li field="classid">
                            <span>选择分类：</span>
                            <a
                                @click="subCategoryId = null"
                                :class="{curr: subCategoryId == null}"
                                style="cursor: pointer;"
                            >不限</a>
                            <a
                                :class="{curr: s.id == subCategoryId}"
                                @click="subCategoryId = s.id"
                                v-for="s in suCategories"
                                style="cursor: pointer;"
                            >{{ s.name }}</a>
                        </li>
                    </ul>
                </section>

                <section class="course-list-wrap">
                    <div class="sub-title" style="text-align: left;">
                        所有课程
                        <i class="lined"></i>
                        <!--            <div class="sub-title-sort">
              <a class="d" href="/vod/e0gz?o-0d"><i></i>综合评分</a>
              <a class="d" href="/vod/e0gz?o-1a"><i></i>学习人数</a>
              <a class="d" href="/vod/e0gz?o-2d"><i></i>浏览量</a>
              <a class="d" href="/vod/e0gz?o-3d"><i></i>更新时间</a>
                        </div>-->
                    </div>
                </section>
            </div>
        </div>

        <section class="con02">
            <div class="page-width">
                <div class="clearfix">
                    <ul>
                        <courseLi :course="course" v-for="course in courses" :key="course.id"></courseLi>
                    </ul>
                </div>
            </div>
        </section>

        <div class="paging" v-show="totalPage > 0">
            <div class="paging-box">
                <a @click="prev">
                    <i class="icon-prev"></i>
                </a>
                <a
                    @click="toPage(item)"
                    :class="{curr :item == page, num : item != page}"
                    v-for="(item, index) in totalPage"
                >{{ item }}</a>
                <a @click="next">
                    <i class="icon-next"></i>
                </a>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import category from './categoryView'
import bottom from './bottom'
import courseLi from '../components/courseLi'

export default {
    name: 'courseList',
    data() {
        let categoryId = this.$router.currentRoute.params.id
        let category = this.$router.currentRoute.params.category
        let suCategories = this.$router.currentRoute.params.children || []
        let subCategoryId = this.$router.currentRoute.params.subId || null
        let page = this.$router.currentRoute.query.page || 1
        let keyword = this.$router.currentRoute.query.keyword || ''
        return {
            categoryId: categoryId,
            category: category,
            subCategoryId: subCategoryId,
            suCategories: suCategories,
            courses: [],
            page: page,
            totalPage: 0,
            keyword: keyword,
            showCategory: 0
        }
    },
    computed: {
        subCategoryName() {
            if (!this.subCategoryId) {
                return '不限'
            }
            for (let s of this.suCategories) {
                if (s.id == this.subCategoryId) {
                    return s.name
                }
            }
        }
    },
    methods: {
        prev() {
            if (this.page > 1) {
                this.toPage(this.page - 1)
            }
        },
        next() {
            if (this.page < this.totalPage) {
                this.toPage(this.page + 1)
            }
        },
        toPage(page) {
            this.page = page
            var query = {}
            if (page && page > 1) {
                query.page = page
            }
            if (this.keyword) {
                query.keyword = this.keyword
            }
            if (this.subCategoryId) {
                this.$router.push({
                    name: 'subCourseList',
                    params: { id: this.categoryId, subId: this.subCategoryId },
                    query: query
                })
            } else if (this.keyword) {
                this.$router.push({ name: 'search', query: query })
            } else {
                this.$router.push({
                    name: 'courseList',
                    params: {
                        id: this.categoryId,
                        category: this.category,
                        children: this.suCategories
                    },
                    query: query
                })
            }
        },
        loadCourses() {
            var _this = this

            var url =
                this.$coursePath +
                '/index/courses?' +
                this.buildLoadCourseParams()
            if (this.page > 1) {
                url += '&page=' + (this.page - 1)
            }
            this.$http.get(url).then(function(result) {
                if (result.data.code == 0) {
                    _this.courses = result.data.data.courses
                    _this.courses = JSON.parse(JSON.stringify(_this.courses))
                    _this.totalPage = Math.ceil(result.data.data.total / 8)
                }
            })
        },
        init() {
            if (!this.category) {
                if (this.categoryId) {
                    this.initCategory()
                } else {
                    this.initSearch()
                }
            } else {
                this.loadCourses()
            }
        },
        buildLoadCourseParams() {
            if (!this.categoryId) {
                return 'search=' + this.keyword
            }
            let result = 'categoryIds='
            var categoryIds = []
            if (this.subCategoryId) {
                categoryIds.push(this.subCategoryId)
            } else {
                categoryIds.push(this.categoryId)
                for (let s of this.suCategories || []) {
                    categoryIds.push(s.id)
                }
            }
            result += categoryIds.join(',')
            return result
        },
        initSearch() {
            this.loadCourses()
        },
        initCategory() {
            var _this = this
            this.$http
                .get(this.$coursePath + '/index/category/' + this.categoryId)
                .then(function(result) {
                    if (result.data.code == 0) {
                        _this.category = result.data.data.category
                        _this.suCategories = result.data.data.suCategories
                        _this.loadCourses()
                    }
                })
        }
    },
    created() {
        this.init()
    },
    components: {
        top,
        category,
        bottom,
        courseLi
    },
    watch: {
        subCategoryId() {
            this.toPage(1)
        },
        $route() {
            let keyword = this.$router.currentRoute.query.keyword
            this.keyword = keyword || ''
            if (keyword) {
                this.categoryId = undefined
                this.category = undefined
                this.suCategories = []
                this.subCategoryId = ''
            } else {
                let categoryId = this.$router.currentRoute.params.id
                let subCategoryId =
                    this.$router.currentRoute.params.subId || null
                if (categoryId != this.categoryId) {
                    let category = this.$router.currentRoute.params.category
                    this.categoryId = categoryId
                    this.category = category
                }
                if (subCategoryId != this.subCategoryId || !subCategoryId) {
                    let suCategories =
                        this.$router.currentRoute.params.children || []
                    this.suCategories = suCategories
                    this.subCategoryId = subCategoryId
                }
            }
            this.loadCourses()
        }
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/page.animate.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
</style>



// WEBPACK FOOTER //
// src/views/courseList.vue